import _get from 'lodash/get';

import { useDB, useAuth, EnumMode, EnumUserType, IUser } from 'store';
import { INVALID_DUO_LOGIN_MESSAGE } from 'utils';

// Second step of an Admin login that needed Duo
export const loginDuo = (payload: { PreAuthToken: string; State: string; DuoCode: string }) =>
  useDB.getState().axios(
    {
      method: 'POST',
      url: '/login/duo',
      data: payload,
    },
    false,
  );

// Error to show for a failed /login/duo call
export const getDuoLoginError = (result: { status?: number; message?: string }): string =>
  result.status === 401 || !result.message ? INVALID_DUO_LOGIN_MESSAGE : result.message;

// Starts the session from a successful /login or /login/duo response.
// Returns an error message instead if the user may not use the portal
export const startSession = (
  result: object,
  navigate: (to: string) => void,
): string | undefined => {
  // Left by the old property login, which had a serial number
  localStorage.removeItem('serialNumber');
  const obj: IUser = _get(result, 'data.data', {
    id: '',
    DisplayName: '',
    token: '',
    Type: EnumUserType.MERCHANT,
    email: '',
    mode: EnumMode.LOGIN,
    Merchant: '', //Will only be blank if ADMIN
  });

  if (
    !obj.AllowViewPaymentSummary &&
    !obj.AllowViewPaymentSettlements &&
    !obj.AllowViewPaymentTransactions
  ) {
    return 'You do not have the rights to access GuestPoint Pay portal.';
  }

  navigate('/');
  useAuth.getState().setUser(obj);
  return undefined;
};
